import { createPrefixedActions } from '@zapier/toolbox-redux-framework';

export default createPrefixedActions(
  'history',
  `
    LOAD_TASKS
    LOAD_TASKS_DONE
    LOAD_TASKS_FAIL

    SEND_CSV
    SEND_CSV_DONE
    SEND_CSV_FAIL

    LOAD_TASK
    LOAD_TASK_DONE
    LOAD_TASK_FAIL

    REPLAY_TASK
    REPLAY_TASK_DONE
    REPLAY_TASK_FAIL

    LOAD_TASK_STATUS
    LOAD_TASK_STATUS_DONE

    SELECT_ALL
    SELECT_SHOWN
    UNSELECT_ALL

    TOGGLE_SELECT_TASK

    MASS_ACTION
    MASS_ACTION_DONE
    MASS_ACTION_FAIL

    CLEAR_DELETED_TASKS

    MARK_DELETED_TASKS
    MARK_SUCCESSFUL_TASKS

    CLOSE_SELECTION_DETAILS
  `
);
